import React from 'react';
import PropTypes from 'prop-types';

import { Container, ContentWrapper } from './styles';

export default function AuthLayout({ children }) {
  return (
    <Container>
      <ContentWrapper>{children}</ContentWrapper>
    </Container>
  );
}

AuthLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
